import type { ErrorEvent } from '@sentry/core'
import { GENERIC_ERROR_TYPES } from '../constants'

const isGenericError = (event: ErrorEvent): boolean => {
  const exception = event?.exception?.values?.[0] ?? {}
  const { type } = exception
  return GENERIC_ERROR_TYPES.some((error) => type === error)
}

export default isGenericError
